import { Text } from "components";
import React from "react";
import "./style.css";
import { getAuthenticated } from "utils/functions";
import { Fonts, FontWeights, FontColors } from "theme/fontConfig";

export const SubHeader = ({ style, title, endSection, ...rest }) => {
  return null;

  // eslint-disable-next-line no-unreachable
  const isAuthenticated = getAuthenticated();

  if (!isAuthenticated) return null;

  return (
    <header className="d-flex w-100 mt-3 mb-6" {...rest} style={{ height: 40 }}>
      <div className="me-auto" style={{ marginInlineEnd: "auto" }}>
        <Text
          style={{
            color: FontColors.Black,
            fontSize: Fonts.GeneralPageHeaderFont.fontSize,
            fontWeight: FontWeights.Medium,
          }}
        >
          {title}
        </Text>
      </div>
      {endSection}
    </header>
  );
};
